<template>
    <div>
        <nova-reserva @new='loadReservas()' ></nova-reserva>
        <card v-for="(reserva,index) in reservas" :key='`reserva-${index}`'>
            <div class='row'>
                <div class='col-md-9 col-12'>
                    <strong>Livro: {{reserva.obra.titulo}}</strong>
                    <div>
                        <small>{{reserva.obra.subtitulo}}</small>
                    </div>
                    <div>
                        <strong>Reservado para: </strong>
                        <span>{{reserva.membro_reservou.full_name}}</span>
                    </div>
                    <div>
                        <strong>Atendente: </strong>
                        <span v-if='reserva.usuario'>{{reserva.usuario.first_name}}</span>
                    </div>
                    <div>
                      <strong>Data da Reserva:</strong>
                      <span>{{reserva.data_reserva | formatDate}}</span>
                    </div>
                </div>
                <div class='col-md-3 col-12'>
                    <button class='btn btn-success btn-block' v-if='!reserva.resolvido' @click='resolver(reserva)'>Resolver</button>
                    <button class='btn btn-danger btn-block' v-else @click='resolver(reserva)'>Desresolver</button>
                </div>
            </div>
        </card>
        <pagination :count='count' :limit='limit' :page='page' @changePage='changePage($event)'></pagination>
    </div>
</template>
<script>
import ReservaService from '../services/reserva-service'
import { Pagination } from '@/components'
import OverlayService from '../services/overlay-service'
import NovaReserva from '../components/Reservas/NovaReserva.vue'

export default {
  components: {
    Pagination,
    NovaReserva
  },

  data () {
    return {
      reservas: [],
      limit: 7,
      count: 0,
      page: 0
    }
  },

  mounted () {
    this.loadReservas()
  },

  methods: {

    resolver (reserva) {
      OverlayService.trigger('show', true)

      ReservaService.resolver(reserva.id, reserva.resolvido ? 0 : 1)
        .then(result => result.data)
        .then(res => {
          reserva.resolvido = res.resolvido

          OverlayService.trigger('show', false)
        }).catch(er => OverlayService.trigger('show', false))
    },

    loadReservas () {
      const order = [{ orderBy: 'id', direction: 'asc' }]

      const filter = {
        limit: this.limit,
        page: this.page + 1,
        orderBy: order,
        resolvido: false
      }

      OverlayService.trigger('show', true)

      ReservaService.getAll(filter)
        .then(result => result.data)
        .then(reservas => {
          this.reservas = reservas.data
          this.count = reservas.total
          OverlayService.trigger('show', false)
        })
        .catch(er => OverlayService.trigger('show', false))
    },

    changePage (page) {
      this.page = page
      this.loadReservas()
    }

  }

}
</script>
